__turbopack_context__.v({
  "bullet": "f6Az9a_bullet",
  "bullet-wrapper": "f6Az9a_bullet-wrapper",
  "extras": "f6Az9a_extras",
});
